<script>
  import MediaQuery from "./MediaQuery.svelte";
    
  export let step;
  
  const data = [
      '1.webp',
      '2.webp',
      '3.webp',
      '4.webp',
      '5.webp',
      '6.webp',
    ]
  
    let Pic;
  
    
    $: {
      if (step == 0) {
  Pic = data.length - 6
      }
      if (step == 1) {
  Pic = data.length - 5
      }
      if (step == 2) {
  Pic = data.length - 4
      }
      if (step == 3) {
  Pic = data.length - 3
      }
      if (step == 4) {
  Pic = data.length - 2
      }
			if (step == 5) {
  Pic = data.length - 1
      }
    }
  
  </script>
  
  <MediaQuery query="(min-width: 550px)" let:matches>
    {#if matches}
		<img src="./pics/desktop/{data[Pic]}" alt=''/>
    {:else}
  <img src="./pics/mobile/{data[Pic]}" alt=''/>
    {/if}
  </MediaQuery>
  
  
  <style>

      img{
        width: auto;
        height: 100vh;
    }

    @media screen and (max-width: 550px) {
      img{
        width: 100%;
        height: auto;
    }
}
		
  </style>